import React from 'react';
import './home.css';
import { Link } from 'react-router-dom';
import Header from '../components/header';
import Waves from '../components/Waves';
import DecryptedText from '../components/DecryptedText';
import LogoLoop from '../components/LogoLoop';
import SpotlightCard from '../components/SpotlightCard';
import {
  SiPython, SiDjango, SiFastapi, SiReact, SiTypescript, SiJavascript,
  SiPostgresql, SiDocker, SiNginx, SiVite, SiFigma, SiNumpy,
  SiApachekafka, SiBootstrap, SiHtml5, SiCss3, SiGithub, SiTailwindcss,
  SiRedis, SiLinux, SiSwagger,
} from 'react-icons/si';

const techLogos = [
  { node: <SiPython color="#3776AB" />, title: 'Python' },
  { node: <SiDjango color="#44B78B" />, title: 'Django' },
  { node: <SiFastapi color="#009688" />, title: 'FastAPI' },
  { node: <SiPostgresql color="#4169E1" />, title: 'PostgreSQL' },
  { node: <SiApachekafka color="#e0e0e0" />, title: 'Kafka' },
  { node: <SiNginx color="#009639" />, title: 'Nginx' },
  { node: <SiRedis color="#FF4438" />, title: 'Redis' },
  { node: <SiSwagger color="#85EA2D" />, title: 'Swagger' },
  { node: <SiReact color="#61DAFB" />, title: 'React' },
  { node: <SiTypescript color="#3178C6" />, title: 'TypeScript' },
  { node: <SiJavascript color="#F7DF1E" />, title: 'JavaScript' },
  { node: <SiHtml5 color="#E34F26" />, title: 'HTML5' },
  { node: <SiCss3 color="#1572B6" />, title: 'CSS3' },
  { node: <SiVite color="#646CFF" />, title: 'Vite' },
  { node: <SiTailwindcss color="#06B6D4" />, title: 'Tailwind' },
  { node: <SiBootstrap color="#7952B3" />, title: 'Bootstrap' },
  { node: <SiFigma color="#F24E1E" />, title: 'Figma' },
  { node: <SiNumpy color="#4DABCF" />, title: 'NumPy' },
  { node: <SiDocker color="#2496ED" />, title: 'Docker' },
  { node: <SiGithub color="#e0e0e0" />, title: 'GitHub' },
  { node: <SiLinux color="#FCC624" />, title: 'Linux' },
];

function Home() {
  return (
    <div className="home-page">
      {/* Waves Background — fixed behind everything */}
      <div className="waves-bg">
        <Waves
          lineColor="#5227ff"
          backgroundColor="transparent"
          waveSpeedX={0.02}
          waveSpeedY={0.01}
          waveAmpX={40}
          waveAmpY={5}
          friction={0.9}
          tension={0.01}
          maxCursorMove={120}
          xGap={12}
          yGap={36}
        />
      </div>

      {/* Navigation */}
      <Header />

      {/* ═══ Hero Section ═══ */}
      <section className="hero-section">
        <div className="hero-inner">
          <div className="hero-text-block fade-in-up">
            <span className="hero-eyebrow">Backend Developer</span>

            <h1 className="hero-heading">
              <DecryptedText
                text="Привет, я"
                animateOn="view"
                speed={55}
                maxIterations={12}
                characters="АБВГДЕЖЗИКЛМНabcdef!@#$%^"
                className="text-white-custom"
                encryptedClassName="text-purple-400"
                parentClassName="hero-decrypted"
              />
              <br />
              <DecryptedText
                text="Александр"
                animateOn="view"
                speed={40}
                maxIterations={15}
                sequential
                revealDirection="start"
                characters="АБВГДЕЖЗИКЛМНОПРСТУabcdefghijk!@#"
                className="text-toxic"
                encryptedClassName="text-purple-500"
                parentClassName="hero-decrypted hero-name"
              />
            </h1>

            <p className="hero-desc-new">
              Проектирую серверную архитектуру, API и базы данных — от концепта до продакшена.
            </p>

            <div className="hero-actions">
              <Link to="/work" className="btn-primary-new cursor-target">
                Смотреть работы
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M7 17L17 7M17 7H7M17 7V17" />
                </svg>
              </Link>
              <Link to="/contact" className="btn-secondary-new cursor-target">
                Связаться
              </Link>
            </div>
          </div>

          {/* Stats */}
          <div className="hero-stats-grid">
            <SpotlightCard
              spotlightColor="rgba(82, 39, 255, 0.5)"
              style={{ padding: '1.5rem', textAlign: 'center' }}
            >
              <span className="stat-num">5</span>
              <span className="stat-lbl">лет в разработке</span>
            </SpotlightCard>

            <SpotlightCard
              spotlightColor="rgba(204, 255, 0, 0.35)"
              style={{ padding: '1.5rem', textAlign: 'center' }}
            >
              <span className="stat-num">89+</span>
              <span className="stat-lbl">проектов</span>
            </SpotlightCard>

            <SpotlightCard
              spotlightColor="rgba(0, 255, 136, 0.35)"
              style={{ padding: '1.5rem', textAlign: 'center' }}
            >
              <span className="stat-num">24/7</span>
              <span className="stat-lbl">на связи</span>
            </SpotlightCard>
          </div>
        </div>
      </section>

      {/* ═══ Skills / Tech Stack Section ═══ */}
      <section className="skills-section">
        <div className="section-header">
          <span className="section-eyebrow">Технологии</span>
          <h2 className="section-heading">Мой стек</h2>
        </div>
        <div className="logoloop-wrapper">
          <LogoLoop
            logos={techLogos}
            speed={80}
            direction="left"
            logoHeight={36}
            gap={48}
            hoverSpeed={0}
            fadeOut
            fadeOutColor="#080808"
            scaleOnHover
            ariaLabel="Tech stack"
          />
        </div>
      </section>

      {/* ═══ Services Section ═══ */}
      <section className="bento-section">
        <div className="section-header">
          <span className="section-eyebrow">Что делаю</span>
          <h2 className="section-heading">Сервисы и процесс</h2>
        </div>

        <div className="home-services-grid">
          {/* Card 1 — What I build */}
          <SpotlightCard spotlightColor="rgba(82, 39, 255, 0.3)" style={{ padding: '2.5rem' }}>
            <div className="home-svc-label">Что разрабатываю</div>
            <h3 className="home-svc-title">Backend&nbsp;&amp; API</h3>
            <ul className="home-svc-list">
              {[
                'REST API и GraphQL сервисы',
                'Микросервисная архитектура',
                'Базы данных, индексы, оптимизация',
                'Очереди и события (Kafka, RabbitMQ)',
                'Аутентификация, OAuth2, JWT',
                'CI/CD, Docker, деплой на сервер',
              ].map((item) => (
                <li key={item} className="home-svc-item">
                  <span className="home-svc-dot" />
                  {item}
                </li>
              ))}
            </ul>
          </SpotlightCard>

          {/* Card 2 — Process */}
          <SpotlightCard spotlightColor="rgba(204, 255, 0, 0.18)" style={{ padding: '2.5rem' }}>
            <div className="home-svc-label">Как строится работа</div>
            <h3 className="home-svc-title">Процесс</h3>
            <ol className="home-process-list">
              {[
                { n: '01', title: 'Бриф', desc: 'Изучаю задачу, требования и ограничения — чтобы не переделывать потом' },
                { n: '02', title: 'Архитектура', desc: 'Проектирую решение, согласую стек и подход до написания кода' },
                { n: '03', title: 'Разработка', desc: 'Пишу код, покрываю тестами, веду документацию' },
                { n: '04', title: 'Деплой', desc: 'Настраиваю окружение, запускаю в продакшн, остаюсь на связи' },
              ].map((step) => (
                <li key={step.n} className="home-process-item">
                  <span className="home-process-num">{step.n}</span>
                  <div>
                    <span className="home-process-title">{step.title}</span>
                    <span className="home-process-desc">{step.desc}</span>
                  </div>
                </li>
              ))}
            </ol>
          </SpotlightCard>
        </div>
      </section>

      {/* ═══ Footer CTA ═══ */}
      <section className="home-cta-section">
        <SpotlightCard
          spotlightColor="rgba(82, 39, 255, 0.4)"
          style={{ padding: '3rem 2rem', textAlign: 'center', maxWidth: '700px', margin: '0 auto' }}
        >
          <p className="cta-label">Готов к новым проектам</p>
          <h2 className="cta-title" style={{ color: '#fff', fontFamily: 'Unbounded, sans-serif' }}>
            Давай создадим что-то{' '}
            <span style={{ color: 'var(--toxic-yellow)' }}>крутое</span>
          </h2>
          <div className="hero-actions" style={{ justifyContent: 'center', marginTop: '2rem' }}>
            <Link to="/contact" className="btn-primary-new cursor-target">
              Связаться
            </Link>
            <Link to="/work" className="btn-secondary-new cursor-target">
              Смотреть работы
            </Link>
          </div>
        </SpotlightCard>
      </section>
    </div>
  );
}

export default Home;
